import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TransactionProvider } from "context/TransactionContext";
import { BankProvider } from "context/BankContext";
import { BridgeDataProvider } from "context/BridgeDataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BridgeDataProvider>
    <BankProvider>
      <TransactionProvider>
        <App />
      </TransactionProvider>
    </BankProvider>
  </BridgeDataProvider>
  // </React.StrictMode>
);

//deployment trigger
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
